<template>
  <v-container>
    <v-card
      color="#efefef"
      class="mb-12"
    >
      <v-row class="px-5 ">
        <v-col
          cols="12"
        >
          <v-form
            ref="form"
            v-model="validForm"
          >
            <div class="text-h3 text-weigth-light ma-6">
              Clip-ON
            </div>
            <!-- colore flitro -->
            <v-row
              justify="center"
              class="ma-0 pa-0"
            >
              <v-col class="text-md-end my-0 py-0          ">
                FILTRO CLIP-ON
              </v-col>
              <v-col
                md="10"
                cols="12"
                class="my-0 py-0"
              >
                <v-autocomplete
                  v-model="steporder['filtro_colore']"
                  :items="colfiltro_clp"
                  :rules="[rules.required]"
                  outlined
                  color="blue-grey lighten-2"
                  label=""
                  item-text="description"
                  return-object
                  clearable
                  class="my-0 py-0 text-body-1"
                  dense
                >
                  <template v-slot:selection="data">
                    <v-avatar
                      rounded
                      left
                    >
                      <v-img
                        :src="`./img/FLT/CLP_0${data.item.tipcompo}.png`"
                        contain
                      />
                    </v-avatar>
                    <span class="pl-4">{{ data.item.codcol }} {{ data.item.coldesc }} </span>
                  </template>
                  <template
                    v-slot:item="data"
                  >
                    <v-list-item-avatar
                      rounded
                      width="30"
                      height="auto"
                      @click="$set(steporder, 'filtro_colore', data.item.codcol);$forceUpdate()"
                    >
                      <v-img
                        :alt="` avatar`"
                        :src="`./img/FLT/CLP_0${data.item.tipcompo}.png`"
                        :lazy-src="'./img/noimage.jpg'"
                        contain
                      />
                    </v-list-item-avatar>
                    <v-list-item-content @click="$set(steporder, 'filtro_colore', data.item.codcol);$forceUpdate()">
                      <v-list-item-title
                        class="pl-4"
                        v-text="`${data.item.codcol} ${data.item.coldesc}` "
                      />
                      <v-list-item-subtitle class="d-none">
                        ./img/FLT/CLP_0{{ data.item.tipcompo }}.png
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- colore componenti -->
            <v-row
              v-for="(piece,idx) in toColorize"
              :key="`piece_${idx}`"
              justify="center"
              class="ma-0 pa-0"
            >
              <v-col class="text-md-end my-0 py-0          ">
                {{ piece.lbl }}
              </v-col>
              <v-col
                md="10"
                cols="12"
                class="my-0 py-0"
              >
                <v-autocomplete
                  v-model="steporder[piece.var]"
                  :items="itemsColors(piece)"
                  :rules="[rules.required]"
                  outlined
                  color="blue-grey lighten-2"
                  label=""
                  item-text="finder"
                  return-object
                  clearable
                  class="my-0 py-0 text-body-1"
                  dense
                >
                  <template v-slot:selection="data">
                    <v-avatar
                      rounded
                      left
                    >
                      <v-img
                        :src="`./img/COL/CLP_${data.item.numcol}.png`"

                        contain
                      />
                    </v-avatar>
                    <span class="pl-4">{{ data.item.numcol }} {{ data.item.codcol }} {{ data.item.coldesc }}</span>
                  </template>
                  <template
                    v-slot:item="data"
                  >
                    <v-list-item-avatar
                      rounded
                      width="30"
                      height="auto"
                    >
                      <v-img
                        :alt="` avatar`"
                        :src="`./img/COL/CLP_${data.item.numcol}.png`"

                        contain
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        class="pl-4"
                        v-text="`${data.item.numcol} ${data.item.codcol} ${data.item.coldesc}` "
                      />
                      <v-list-item-subtitle class="d-none">
                        ./img/COL/{{ $linea().label }}_{{ data.item.numcol }}.png
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- CLIP-ON ABBINATO -->
          </v-form>
        </v-col>
      </v-row>
    </v-card>
    <v-btn
      color="primary"
      :disabled="!validForm "
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Step2',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {

        steporder: {},
        validForm: true,
        colponte_clp: [],
        colperni_clp: [],
        colfiltro_clp: [],
        compo: [],
        vincoli: [],
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      toColorize () {
        return [
          { compo: 'PONT', tipcompo: '1', lbl: 'PONTE', var: 'colclp_ponte' },
          { compo: 'PERN', tipcompo: '1', lbl: 'PERNO PONTE DX', var: 'colclp_perpon_dx' },
          { compo: 'PERN', tipcompo: '1', lbl: 'PERNO PONTE SX', var: 'colclp_perpon_sx' },
        ]
      },

    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    created () {

    },
    mounted () {
      console.log('mount CLP', this.step)
      this.initData(this.step)
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        console.log('initdata', stp)
        // patch per condividere clipon su altre linee
        if ((this.order.codart === 'CLP' && this.$options.name === `Step${stp}`) || (this.order.codart === 'SWF' && stp === 5)) {
          console.log('loadCLP compo', stp)
          this.steporder = Object.assign({}, this.order)
          // if (this.compo && this.compo.length === 0) {
          this.loadDataClp()
          // }
        }
      },
      itemsColors (piece) {
        return piece.compo === 'PONT' ? this.colponte_clp : this.colperni_clp.filter(item => (item.compo === piece.compo && item.tipcompo === piece.tipcompo))
      },
      loadDataClp () {
        this.loading = true
        engine.get_compo('CLP')
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }
            this.compo = result.data
            this.vincoli = result.vincoli
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })

        engine.get_colcompo('CLP')
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }
            console.log('colcompo', result)
            this.colponte_clp = result.data.filter(item => item.compo === 'PONT').sort((a, b) => a.numcol - b.numcol)
            this.colfiltro_clp = result.data.filter(item => item.compo === 'FLT').sort((a, b) => a.numcol - b.numcol)
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })

        // carico colori da SWF
        engine.get_colcompo('SWF')
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }

            this.colperni_clp = result.data.filter(item => item.compo === 'PERN').map((item) => {
              if (+item.numcol === 198) item.numcol = 98
              if (+item.numcol === 199) item.numcol = 99

              return item
            }).sort((a, b) => a.numcol - b.numcol)
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })
      },

      nextStep () {
        if (!this.validForm) { return }
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        console.log('steporder', this.steporder)
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
      prevStep () {
        this.$emit('prevStep', this.step)
      },
    },
  }
</script>
